<template>
  <div class="modal-dim on">
    <!--'on 추가'-->
    <div class="modal-wrap">
      <div class="modal-inner center">
        <div class="modal">
          <div class="modal-head">
            <h1>비밀번호 변경</h1>
          </div>
          <div class="modal-con">
            <div class="form-wrap">
              <form>
                <div class="form">
                  <ul class="form-ul">
                    <li class="form-li">
                      <div class="form-ttl ">
                        <span>현재 비밀번호</span>
                      </div>
                      <div class="form-in">
                        <label class="label">
                          <input
                            type="password"
                            v-model="state.form.password"
                            :class="{ on: valid.form.password.$error }"
                            placeholder="영문,숫자 포함 6자리 이상"
                          />
                        </label>
                      </div>
                      <div class="valid" :class="{ on: valid.form.password.$error }">{{ state.msg.password }}</div>
                    </li>
                    <li class="form-li">
                      <div class="form-ttl ">
                        <span>변경할 비밀번호</span>
                      </div>
                      <div class="form-in">
                        <label class="label">
                          <input
                            type="password"
                            :class="{ on: valid.form.newPassword.$error }"
                            v-model="state.form.newPassword"
                            placeholder="영문,숫자 포함 6자리 이상"
                          />
                        </label>
                      </div>
                      <div class="valid" :class="{ on: valid.form.newPassword.$error }">
                        {{ state.msg.newPassword }}
                      </div>
                    </li>
                    <li class="form-li">
                      <div class="form-ttl ">
                        <span>비밀번호 확인</span>
                      </div>
                      <div class="form-in">
                        <label class="label">
                          <input
                            type="password"
                            v-model="state.form.confirmPassword"
                            :class="{ on: valid.form.confirmPassword.$error }"
                            placeholder="영문,숫자 포함 6자리 이상"
                          />
                        </label>
                      </div>
                      <div class="valid" :class="{ on: valid.form.confirmPassword.$error }">
                        {{ state.msg.confirmPassword }}
                      </div>
                    </li>
                  </ul>
                </div>
              </form>
            </div>
          </div>
          <div class="modal-btn">
            <div class="btn-wrap">
              <button class="btn black" @click.prevent="$emit('close')">닫기</button>
              <button class="btn" @click.prevent="fnUpdatePassword">비밀번호 변경</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PASSWORD_UPDATE_FORM'
};
</script>
<script setup>
import { defineProps, reactive, ref } from 'vue';
import { useModalState } from '@/common/state/modalState';
import { useVuelidate } from '@vuelidate/core';
import { useStore } from 'vuex';
import { modalAlertNames } from '@/components/common/globalComponent';
import Util from '@/common/utils/Util';
import { required } from '@vuelidate/validators';
const { fnModalAlert } = useModalState();
const { dispatch } = useStore();

const props = defineProps({
  userNo: {
    type: Object
  }
});

const state = reactive({
  form: {
    userNo: '',
    password: '',
    newPassword: '',
    confirmPassword: ''
  },
  msg: {
    password: '비밀번호를 입력해 주세요.',
    newPassword: '비밀번호를 입력해 주세요.',
    confirmPassword: '비밀번호를 입력해 주세요.'
  }
});

const rules = {
  form: {
    password: {
      test: function(val) {
        if (!val) {
          return false;
        }
        if (!Util.isPasswordValid(val)) {
          state.msg.password = '영문,숫자 포함 6자리 이상 입력해 주세요.';
          return false;
        }
        return true;
      }
    },
    newPassword: {
      test: function(val) {
        if (!val) {
          return false;
        }
        if (!Util.isPasswordValid(val)) {
          state.msg.newPassword = '영문,숫자 포함 6자리 이상 입력해 주세요.';
          return false;
        }
        if (val === state.form.password) {
          state.msg.newPassword = '기존 비밀번호와 같은 비밀번호입니다.';
          return false;
        }
        return true;
      }
    },
    confirmPassword: {
      test: function(val) {
        if (!val) {
          return false;
        }
        if (state.form.newPassword !== val) {
          state.msg.confirmPassword = '입력한 비밀번호가 일치하지 않습니다.';
          return false;
        } else {
          return true;
        }
      }
    }
  }
};

const valid = useVuelidate(rules, state);

const fnUpdatePassword = async () => {
  valid.value.$touch();
  if (valid.value.$invalid) return;

  const payload = {
    userNo: props.userNo,
    password: state.form.password,
    newPassword: state.form.newPassword
  };

  const response = await dispatch('user/updatePassword', payload);

  if (response.code === 1) {
    await dispatch('layout/pushModalAlertComponent', {
      component: modalAlertNames.BASE,
      callBackText: '확인',
      layout: { title: '', contents: '비밀번호가 변경되었습니다.' },
      callBack: async proxy => {
        await dispatch('layout/removeAllModalAlertComponent');
      }
    });
  } else {
    await dispatch('layout/pushModalAlertComponent', {
      component: modalAlertNames.BASE,
      callBackText: '확인',
      layout: { title: '', contents: response.message },
      callBack: async () => {
        await dispatch('layout/closeModalAlertComponent', { index: 1 });
      }
    });
  }
};
</script>

<style lang="scss" scoped></style>
